export var AlertCssClass;
(function (AlertCssClass) {
    AlertCssClass["Base"] = "iress-alert";
    AlertCssClass["Heading"] = "iress-alert__heading";
    AlertCssClass["Footer"] = "iress-alert__footer";
    AlertCssClass["HasHeading"] = "iress-alert--has-heading";
    AlertCssClass["Wrapper"] = "iress-alert__wrapper";
})(AlertCssClass || (AlertCssClass = {}));
export var AlertSlot;
(function (AlertSlot) {
    AlertSlot["Footer"] = "footer";
})(AlertSlot || (AlertSlot = {}));
//# sourceMappingURL=alert.types.js.map